<template>
    <v-row class="pb-3">
        <v-col cols="2" class="pb-5">
            <SearchFilter 
                @keydown.enter="filter" 
                :context="context" 
                :alvqa="alvqa + '-textfield-search'"
                :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_PANEL_WORKS_SEARCH_FIELD')"
            />
        </v-col>
        <span class="pt-7">
            <BaseIcon 
                :alvqa="alvqa + '-icon-search'"
                @click="filter" 
                icon="fa-search" 
                tooltipText="lang_GENERAL_CAPTION_START_SEARCH" 
            />
        </span>
        <v-col 
            cols="2" 
            align-self="center"
            class="pt-6"
        >
            <BaseButton 
                :disabled="!showDeleteResultListButton"
                @click="deleteResultlist"
                label="lang_GENERIC_BUTTON_CAPTION_REMOVE"
                :alvqa="alvqa + '-button-delete-result'"
                block
            />
        </v-col>
        <v-col 
            cols="3"
            align-self="center"
            class="v-label theme--light mt-2"
        >
            <BaseHeaderStats 
                context="WorksForSubCatalogues" 
                typeStats="LIST"
                :alvqa="alvqa"
                :specificSelected="$store.getters.getTotalListed"
            />
        </v-col>
        <v-spacer></v-spacer>
        <v-col v-if="setTypeOfWorksFor === 'SLG'" cols="2" align-self="center" class="pt-6">
            <BaseTooltip :alvqa="alvqa + '-tooltip-change-to-spw'">
                <template v-slot:content>
                    <BaseButton
                        label="lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_SPW_BUTTON"
                        @click="openSetWorksTypeConfirmationDialog('spw')"
                        :disabled="disableSetWorksTypeButton"
                        :alvqa="alvqa + '-button-change-to-spw'"
                        block
                    />
                </template>
                <template v-slot:text>
                    <span>{{ $t('lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_SPW_BUTTON_TOOLTIP') }}</span>
                </template>
            </BaseTooltip>
        </v-col>
        <v-col v-if="['EKT', 'EDV', 'ADV'].includes(setTypeOfWorksFor)" cols="2" align-self="center" class="pt-6">
            <BaseButton
                label="lang_PUBLISH_CONTRACTS_WORKS_CONVERT_TO_OPW_BUTTON"
                @click="openSetWorksTypeConfirmationDialog('opw')"
                :disabled="disableSetWorksTypeButton"
                :alvqa="alvqa + '-button-change-to-opw'"
                block
            />
        </v-col>
        <v-col cols="2" align-self="center" class="pt-6">
            <BaseButton 
                @click="addWorks"
                :disabled="$route.params.alvId === 'new'"
                label="lang_CONTRACTS_PUBLISHING_ADD_WORKS_DIALOG_TITLE"
                :alvqa="alvqa + '-button-add-row'"
                block
            />
        </v-col>
    </v-row>
</template>

<script>
import BaseButton from '@/components/_buttons/BaseButton'
import SearchFilter from '@/components/_filters/SearchFilter'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseHeaderStats from '@/components/_base/BaseHeaderStats'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
    name: "PublishingContractsWorksEditPanelTopSlot",
    components: {
        BaseButton,
        BaseIcon,
        SearchFilter,
        BaseHeaderStats,
        BaseTooltip
    },
    props: {
        subcatalogue: Object
    },
    data() {
        return {
            alvqa: 'contracts-publishing-edit-form-panel-works',
            context: 'PublishingContractsWorks'
        }
    },
    computed: {
        showDeleteResultListButton() { return this.$store.getters.getShowWorksDeleteResultListButton },
        setTypeOfWorksFor()     { return this.$store.getters.getPublishingContractsDetailsContractType},
        disableSetWorksTypeButton()  {
            if(this.$store.getters.getPublishingContractsDetailsAlvId === 'ALV000000000CP' ||
               this.$store.getters.getPublishingContractsWorks.length === 0){
                return true
            }else{
                return false
            }
        },
    },
    methods: {
        openSetWorksTypeConfirmationDialog(type){
            this.$store.commit('setShowSetWorksTypeDialog', true)
        },
        addWorks() {
            this.$store.commit('setShowSearchDialog', true)
        },
        filter() {
            this.$store.commit('setCurrentPage', 1)
            this.$store.dispatch('fetchPublishingContractsWorks')
        },
        deleteResultlist() {
            // this.$store.commit('setSelectedPublishingContractsSubCatalogues', this.subcatalogue.alvId)
            this.$store.commit('setDeletionDialogContext', 'AllWorksFromPublishingContract')
            this.$store.commit('setShowDeletionDialog', true)
        }
    }
}
</script>